// extracted by mini-css-extract-plugin
module.exports = {"root":"📦AssetCardHorizontal__root--2G4Yq","inner":"📦AssetCardHorizontal__inner--1WPvr","thumbnail":"📦AssetCardHorizontal__thumbnail--30kxa"};